// tslint:disable:template-cyclomatic-complexity
import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
} from '@angular/core';
import { Color } from '~app/shared/enums/color.enum';
import { Icon } from '~app/shared/enums/icon.enum';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent implements AfterViewChecked {
  @Input() public icon: Icon;
  @Input() public position: 0 | 1 | 2 | 3 = 0;
  @Input() public color: Color = Color.DarkBlack;
  @Input() public color2: Color = Color.LightGreen;
  @Input() public width?: number;
  @Input() public animationSpeed = 0;

  public Icon = Icon;
  public automaticWidth: number;
  public automaticHeight: number;

  constructor(private readonly el: ElementRef, private readonly cdr: ChangeDetectorRef) {}

  public ngAfterViewChecked(): void {
    try {
      const svg = this.el.nativeElement.children[0].children[0];
      if (this.width) {
        const defaultWidth = svg.viewBox.baseVal.width;
        const scale = this.width / defaultWidth;
        this.automaticWidth = this.width;
        this.automaticHeight = svg.viewBox.baseVal.height * scale;
      } else {
        this.automaticWidth = svg.viewBox.baseVal.width;
        this.automaticHeight = svg.viewBox.baseVal.height;
      }

      this.el.nativeElement.style.width = `${this.automaticWidth}px`;
      this.el.nativeElement.style.height = `${this.automaticHeight}px`;
      this.el.nativeElement.style.transitionDuration = `${this.animationSpeed}ms`;

      switch (this.position) {
        case 1:
          this.el.nativeElement.style.transform = 'rotate(90deg)';
          break;
        case 2:
          this.el.nativeElement.style.transform = 'rotate(180deg)';
          break;
        case 3:
          this.el.nativeElement.style.transform = 'rotate(270deg)';
          break;
        default:
          this.el.nativeElement.style.transform = 'rotate(0deg)';
      }
      this.cdr.detectChanges();
      // tslint:disable-next-line: no-empty
    } catch (error) {}
  }
}
